function observeInView(selector = '[data-observe]') {
    const elements = document.querySelectorAll(selector);

    elements.forEach((el) => {
        const threshold = parseFloat(el.dataset.observeThreshold) || 0.5;
        const offset = parseInt(el.dataset.observeOffset) || 0;
        const once = el.hasAttribute('data-observe-once');
        const delay = parseInt(el.dataset.observeDelay) || 0;

        const observer = new IntersectionObserver(
            ([entry], obs) => {
                if (entry.isIntersecting) {
                    if (delay > 0) {
                        setTimeout(() => {
                            el.setAttribute('data-observe-in-view', '');
                        }, delay);
                    } else {
                        el.setAttribute('data-observe-in-view', '');
                    }

                    if (once) {
                        obs.unobserve(el);
                    }
                } else {
                    if (!once) {
                        el.removeAttribute('data-observe-in-view');
                    }
                }
            },
            {
                threshold: threshold,
                rootMargin: `0px 0px -${offset}px 0px`,
            },
        );

        observer.observe(el);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    observeInView('[data-observe]');
});
